import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { FleetApiService } from '../services/api/fleet-api.service';
import { combineLatest, filter, map, of, switchMap, take } from 'rxjs';
import { environment } from '../../environments/environment';
import { LoggingService } from '@fleet-monitor/frontend-logging';

// Redirects authenticated users with no fleets to onboarding
export const onboardingGuard: CanActivateFn = (_route, _state) => {
  const auth = inject(AuthService);
  const api = inject(FleetApiService);
  const router = inject(Router);
  const logger = inject(LoggingService);

  // E2E bypass keeps existing behavior
  try {
    if (
      !environment.production &&
      typeof window !== 'undefined' &&
      window.localStorage.getItem('E2E_TEST_AUTH') === '1'
    ) {
      return true;
    }
  } catch (error) {
    logger.warn('[onboardingGuard] Unable to read E2E bypass flag', error);
  }

  return combineLatest([auth.isLoading$, auth.isAuthenticated$]).pipe(
    filter(([loading]) => !loading),
    take(1),
    switchMap(([, isAuthed]) => {
      if (!isAuthed) return of(true);
      return api.getFleets().pipe(
        map((res) => {
          const hasFleet = (res.fleets || []).length > 0;
          if (!hasFleet) return router.createUrlTree(['/onboarding']);
          return true as true | UrlTree;
        })
      );
    })
  );
};
